/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { InvitationsControllerBulkCreateMutationRequest, InvitationsControllerBulkCreateMutationResponse, InvitationsControllerBulkCreate400, InvitationsControllerBulkCreate401 } from "../../models/invitationsController/InvitationsControllerBulkCreate";

function getInvitationsControllerBulkCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/invitations/bulk` as const }  
  return res
}

/**
 * @description Create multiple invitations in a single call. Supports partial success - if some items fail, the successful ones are still created. Returns 200 if all items succeed, 207 Multi-Status if some items fail.
 * @summary Bulk create invitations
 * {@link /api/v1/invitations/bulk}
 */
export async function invitationsControllerBulkCreate(data: InvitationsControllerBulkCreateMutationRequest, config: Partial<RequestConfig<InvitationsControllerBulkCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<InvitationsControllerBulkCreateMutationResponse, ResponseErrorConfig<InvitationsControllerBulkCreate400 | InvitationsControllerBulkCreate401>, InvitationsControllerBulkCreateMutationRequest>({ method : "POST", url : getInvitationsControllerBulkCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}